var _defs, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Build_Layer",
    "data-name": "Build Layer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c88205;}.cls-2{fill:#fff;}.cls-3{fill:#001751;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-name-md-outline copy 125") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75,
    cy: 75,
    r: 75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.737,80.838c-9.942-15.688-16.8-43.29-37.389-43.29-9.411,0-21.258,5.4-27.5,13.614-8.441,11.1-13.677,21.063-30.406,24.932L19.354,79.611v8.081A14.35,14.35,0,0,0,33.7,102.042s4.579.461,48.334,0S131.684,87.065,127.737,80.838Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.614,109.548h0a15.5,15.5,0,0,1-15.5-15.5V41.13c5.489,2.611,12.5,8.007,15.511,15.561L132.033,88.35A15.5,15.5,0,0,1,117.614,109.548Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.006,75.955c-.189.046-.372.095-.564.139L19.354,79.611v8.081a14.316,14.316,0,0,0,.232,2.5A14.506,14.506,0,0,0,33.006,75.955Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no_photo.849c46fb33f98b906e4a25f78c990b29.svg";
export { ForwardRef as ReactComponent };